module.exports = __webpack_public_path__ + "staticcomp/img/top.92c0698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/top.jpg
// module id = xZwh
// module chunks = 39